export const manifest = {
  screens: {
    scr_4kzywk: { name: "Order Queue", route: "/", state: {"selectedOrderId":null,"activeTab":"dashboard"}, position: {"x":160,"y":220} },
    scr_t9f7fv: { name: "Order Details - Pending", route: "/", state: {"selectedOrderId":"ORD-7721","activeTab":"dashboard"}, position: {"x":1560,"y":220} },
    scr_b6rb0v: { name: "Continuous Picking", route: "/", state: {"selectedOrderId":"ORD-7723","activeTab":"dashboard","showGlobalScanModal":true,"scanningItem":null}, position: {"x":160,"y":2200} },
    scr_mgjp0a: { name: "Cancel Order Modal", route: "/", state: {"selectedOrderId":"ORD-7721","activeTab":"dashboard","showRejectModal":true}, position: {"x":5760,"y":220} },
    scr_i3xxjf: { name: "Driver Assigned", route: "/", state: {"selectedOrderId":"ORD-7724","activeTab":"dashboard"}, position: {"x":7160,"y":220} },
    scr_y0ctfk: { name: "Delivery Failed - Hold Modal", route: "/", state: {"selectedOrderId":"ORD-7724","activeTab":"dashboard","showHoldModal":true}, position: {"x":9960,"y":220} },
    scr_c0yuwb: { name: "Self Pickup OTP Confirmation", route: "/", state: {"selectedOrderId":"ORD-8801","activeTab":"dashboard","showOtpModal":true}, position: {"x":8560,"y":220} },
  },
  sections: {
    sec_4zhurn: { name: "Order Management", x: 0, y: 0, width: 14120, height: 1180 },
    sec_zvenb3: { name: "Continuous Picking", x: 0, y: 1980, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_4zhurn", children: [
      { kind: "screen", id: "scr_4kzywk" },
      { kind: "screen", id: "scr_t9f7fv" },
      { kind: "screen", id: "scr_mgjp0a" },
      { kind: "screen", id: "scr_i3xxjf" },
      { kind: "screen", id: "scr_c0yuwb" },
      { kind: "screen", id: "scr_y0ctfk" },
    ] },
    { kind: "section", id: "sec_zvenb3", children: [
      { kind: "screen", id: "scr_b6rb0v" },
    ] },
  ],
}
